import React from 'react';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import { FacetPageType } from '../../../types/api';

export interface Props {
  facet?: FacetPageType;
}

function getHeadingText(t: TFunction, facet?: FacetPageType) {
  switch (facet) {
    // TODO: Make sure we don't need more here
    case 'rfy':
      return t('facetPage.heading.rfy');
    case 'deviants-you-watch':
      return t('facetPage.heading.deviants-you-watch');
    case 'posts':
      return t('facetPage.heading.posts');
    case 'popular':
      return t('facetPage.heading.popular');
    case 'polls':
      return t('facetPage.heading.polls');
    case 'dailydeviations':
      return t('facetPage.heading.dailydeviations');
    case 'browse_home':
      return t('facetPage.heading.home');
    default:
      return null;
  }
}

const BrowsePageHeading: React.FC<Props> = ({ facet }) => {
  const { t } = useTranslation();
  const shouldRenderH1 = useFlag('proposed_h1s');
  const headingText = getHeadingText(t, facet);

  return shouldRenderH1 && headingText ? (
    <VisuallyHidden>
      <h1>{headingText}</h1>
    </VisuallyHidden>
  ) : null;
};
BrowsePageHeading.displayName = 'PageHeading';

export default BrowsePageHeading;
